import type { ModelKey } from 'customer-flows/utils/quote/models'

export type Relationship = 'belongsTo' | 'hasMany'
export type RelationshipNode<T extends Relationship = Relationship, M extends ModelKey = ModelKey> = {
  kind: T
  model?: M
  /**
   * Whether this relationship should always be included in the quote.
   */
  composePolicy?: 'always' // TODO: support 'once' in the future for including at least once, the first time. Can still be overridden by an include call
}

/**
 * Defines a belongsTo relationship in the quote schema.
 * @param model - The model key this relationship points to.
 * @param options - Additional options for the relationship.
 *  - composePolicy: When 'always', this model will always be composed.
 */
export function belongsTo<T extends ModelKey>(model?: T, { composePolicy }: { composePolicy?: 'always' } = {}): RelationshipNode<'belongsTo', T> {
  return {
    kind: 'belongsTo',
    model,
    composePolicy
  }
}

/**
 * Defines a hasMany relationship in the quote schema.
 * @param model - The model key this relationship points to.
 * @param options - Additional options for the relationship.
 *  - composePolicy: When 'always', this model will always be composed.
 */
export function hasMany<T extends ModelKey>(model?: T, { composePolicy }: { composePolicy?: 'always' } = {}): RelationshipNode<'hasMany', T> {
  return {
    kind: 'hasMany',
    model,
    composePolicy
  }
}
